// extracted by mini-css-extract-plugin
module.exports = {"widgetRow":"_ef620ad","widgetHeaderRow":"_b21dec0"};